import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  SubmitQuestion,
} from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';
import { templeteUpdateQuestions } from '../api/constants';
import { templateList } from '../constants';

type useUpdateTemplateApplicationQuestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateTemplateApplicationQuestion = ({
  setErrorText = () => { },
}: useUpdateTemplateApplicationQuestionProps) => {
  const client = useQueryClient();

  const {
    mutate: updateApplicationQuestion,
    isLoading: isUpdateApplicationQuestionLoading,
  } = useMutation({
    mutationFn: (variables: SubmitQuestion) =>
      axiosInstance
        .post(templeteUpdateQuestions, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        client.invalidateQueries([templateList]);
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { updateApplicationQuestion, isUpdateApplicationQuestionLoading };
};
